import PerformanceHelper from '../helpers/performance_helper';

/* eslint-disable no-param-reassign, class-methods-use-this, no-undef */
class DelayedGustoAnalytics {
  constructor() {
    const performanceHelper = new PerformanceHelper();
    performanceHelper.executeFunctionOnLoad(function(self) {
      setTimeout(function() {
        self.addDelayedScriptsOnLoad();
      }, 2500); // This timeout is hardcoded intentionally
    }, this);
  }

  /**
   * Finds all the scripts of type 'deferjs' and injects them in the document -- a true delayed execution unlike 'defer'
   */
  addDelayedScriptsOnLoad() {
    const links = document.querySelectorAll('script[type=deferjs]');
    if (links.length === 0) {
      return;
    }

    console.debug(`Loading ${links.length} helpers`);

    // Ensure that we queue the loading of this javascript
    links.forEach(element => {
      console.debug(`Adding ${element.src} to document`);
      try {
        const scriptTag = document.createElement('script');
        scriptTag.src = element.src;
        scriptTag.defer = 'defer';
        document.body.appendChild(scriptTag);
        element.setAttribute('type', 'gusto_analytics_loaded');
      } catch {
        console.debug('There was an error adding the script.');
      }
    });
  }
}

const DELAYED_GUSTO_ANALYTICS = new DelayedGustoAnalytics();
export default new (function() {
  return DELAYED_GUSTO_ANALYTICS;
})();
